module.exports = __webpack_public_path__ + "img/근골격계부담작업의_범위.1190593c.jpg";